module.exports = __webpack_public_path__ + "img/Extra-9-548x353.a34b5cef.jpg";